import 'Components/AppComponents/QuestionBox/QuestionBox.css';
import { BOT_ENERGY_CARD_CORRECT_ANS_DELAY, BOT_ENERGY_CARD_INCORRECT_ANS_DELAY } from 'Constants/BotData';
import { PLAYER_ENERGY_CARD_WRONG_ANS_CUT_TIME } from 'Constants/GameData';
import { AudioHelper } from 'Helpers/AudioHelper';
import { OptionsObjectType, QuestionnaireObjectType } from 'Models/Questionnaires';
import { useState, useEffect } from 'react';
type QuestionBoxPropTypes = {
    questionnaire: QuestionnaireObjectType;
    setAnswers?: Function;
    computerQuestion?: boolean;
    correctAnswer?: boolean
};

const QuestionBox = ({ questionnaire, setAnswers = ()=> {}, computerQuestion = false, correctAnswer = false }: QuestionBoxPropTypes) => {
    const [selectedAnswers, setSelectedAnswers] = useState<number[]>([]);
    const [submitted, setSubmitted] = useState<boolean>(false);

    useEffect(() => {
        setTimeout(() => {
            document.getElementById('question-box')!.style.maxWidth = '1104px';
            document.getElementById('question-box')!.style.maxHeight = '500px';
            document.getElementById('question-box')?.classList.remove('test');

            var i = 0;
            var txt = questionnaire.Question; /* The text */
            var speed = 15; /* The speed/duration of the effect in milliseconds */
            const element = document.getElementById('question-container');
            function typeWriter() {
                if (element) {
                    if (i < txt.length) {
                        element.innerHTML += txt.charAt(i);
                        i++;
                        setTimeout(typeWriter, speed);
                    } else {
                        document.getElementById('options')?.classList.remove('contains-fade');
                        document.getElementById('submit-button')?.classList.remove('contains-fade');
                        if(computerQuestion) {
                            setTimeout(() => {
                                if(correctAnswer) {
                                    questionnaire.Options.filter(x=> x.IsAnswer).forEach((element, index) => {
                                        if(document.getElementById(element?.OptionId)) {
                                            setTimeout(() => {      
                                                AudioHelper.playSound('Card_and_Answer_Selection');                                      
                                                const el = document.getElementById(element.OptionId) as HTMLInputElement;
                                                el.checked = true;
                                            }, 300*index);
                                        } 
                                    });
                                } else {
                                    questionnaire.Options.forEach((element, idx) => {
                                        if(element.IsAnswer && document.getElementById(questionnaire.Options[idx+1]?.OptionId)) {
                                            setTimeout(() => {    
                                                AudioHelper.playSound('Card_and_Answer_Selection');                                    
                                                const el = document.getElementById(questionnaire.Options[idx+1].OptionId) as HTMLInputElement;
                                                el.checked = true;
                                            }, 300*idx);
                                        } else if (idx + 1  === questionnaire.Options.length && element.IsAnswer && document.getElementById(questionnaire.Options[0]?.OptionId)) {
                                            setTimeout(() => {    
                                                AudioHelper.playSound('Card_and_Answer_Selection');                                    
                                                const el = document.getElementById(questionnaire.Options[0].OptionId) as HTMLInputElement;
                                                el.checked = true;
                                            }, 300*idx);
                                        }
                                    });
                                }
                                setTimeout(() => {
                                    document.getElementById('options')?.classList.add('submitted-options');
                                    if (correctAnswer) {
                                        AudioHelper.playSound('Energy_Quiz_Correct_Answer_1st_sound');
                                    } else {
                                        AudioHelper.playSound('Energy_Quiz_Incorrect_Answer_1st_sound');
                                    }
                                }, 1500);                                
                            }, 2500);   
                        }                                             
                    }
                }
            }

            if (!element?.innerHTML) {
                setTimeout(typeWriter, speed + 1000);
            }
            if(computerQuestion) {
                setTimeout(() => {
                    document.getElementById('question-box')?.classList.add('submitted');
                }, correctAnswer? (BOT_ENERGY_CARD_CORRECT_ANS_DELAY + 7000) : (BOT_ENERGY_CARD_INCORRECT_ANS_DELAY + 7000));
            }            
        }, 1000);
    }, [questionnaire.Question]);

    const handleSubmit = () => {

        const element = document.getElementById('question-box');        
        if(selectedAnswers.length === 0) {
            element?.classList.add('shakeX');
            element?.classList.remove('rotate-90-class');
            setTimeout(() => {
                element?.classList.remove('shakeX');
            }, 500);
            document.getElementById('error-message')?.classList.remove('contains-fade-right');
        }
        else if (element) {
            const correctAnswers: number[] = [];
            questionnaire?.Options.forEach((opt: OptionsObjectType, idx: number) => (opt.IsAnswer ? correctAnswers.push(idx) : null));
            let answerNotFound = false;
            if (correctAnswers.length === selectedAnswers?.length) {
                for (let index = 0; index < correctAnswers.length; index++) {
                    if (!selectedAnswers.includes(correctAnswers[index])) {
                        answerNotFound = true;
                        break;
                    }
                }
                if (answerNotFound === false) {
                    AudioHelper.playSound('Energy_Quiz_Correct_Answer_1st_sound');
                }
            } else {
                answerNotFound = true;
            }
            if (answerNotFound === true) {
                AudioHelper.playSound('Energy_Quiz_Incorrect_Answer_1st_sound');
            }
            setSubmitted(true);
            document.getElementById('options')?.classList.add('submitted-options');
            setTimeout(() => {
                element.classList.add('submitted');
                AudioHelper.playSound('Card_Transfer_Deck_to_Across_Screen_slow_down');
                document.getElementById('board-container')?.classList.remove('blur-on');
                setAnswers(selectedAnswers);
            }, !answerNotFound? 3000 : 3000 - PLAYER_ENERGY_CARD_WRONG_ANS_CUT_TIME);            
        }
    };

    const handleClick = (event: any) => {  
        document.getElementById(event.target.value + '-option')!.classList.add('option-zoom-bounce');
        AudioHelper.playSound('Card_and_Answer_Selection');
        setTimeout(() => {
            document.getElementById(event.target.value+'-option')!.classList.remove('option-zoom-bounce');
        }, 500);      
        if (event.target.checked && !selectedAnswers.includes(Number(event.target.value))) {
            setSelectedAnswers([...selectedAnswers, Number(event.target.value)]);       
            console.log(selectedAnswers, questionnaire);     
        } else if (!event.target.checked && selectedAnswers.includes(Number(event.target.value))) {
            setSelectedAnswers(selectedAnswers.filter((x) => x !== Number(event.target.value)));
        }
    };

    return (
        <div id="question-box" className="questionBox relative test rotate-90-class bg-white rounded-lg py-6 px-12 mx-12 duration-1000" style={{ maxWidth: '216px', maxHeight: '302.15px' }}>
            <div className="ss duration-1000" style={{ backgroundImage: `url('/images/Pattern.png')`, backgroundSize: '1150px', backgroundPosition: 'center' }}></div>
            <div className="duration-1000">
                <div id="question-container" style={{ maxWidth: '1008px', width: questionnaire.Question.length * 13 + 'px', minHeight: (questionnaire.Question.length * 32) / 60 + 'px' }} className="text-2xl mb-10 font-bold"></div>
                <div id="options" className={" contains-fade duration-1000 " +( computerQuestion? 'pointer-event-none' : '')}>
                    <ul className="space-y-3">
                        {questionnaire.Options.map((option: OptionsObjectType, idx: number) => {
                            return (
                                <li key={option.OptionId} id={idx+'-option'} className="flex items-center space-x-5">
                                    <label className={"checkbox-container" + ((submitted || computerQuestion) ?  " pointer-event-none " : " cursor-pointer checkbox-container-hover ")}>
                                        <label htmlFor={option.OptionId} className={"text-lg font-medium duration-500 " + (option.IsAnswer? " correct-answer " : "") + ((submitted || computerQuestion) ?  " cursor-default " : " cursor-pointer ") }>
                                            {option.Title}
                                        </label>
                                        <input type="checkbox" className={(submitted || computerQuestion) ?  " cursor-default " : " cursor-pointer "} disabled={submitted || computerQuestion} onChange={handleClick} id={option.OptionId} name={option.OptionId} value={idx} />
                                        <span className="checkmark"></span>
                                    </label>
                                </li>
                            );
                        })}
                    </ul>
                    
                </div>
                {!computerQuestion && <> 
                    <div id="error-message" className="my-6 contains-fade-right delay-500 duration-1000 text-sm text-red">
                        *Please select your answer.
                    </div>
                    <div id="submit-button" className="text-center contains-fade delay-1000 duration-1000">
                        <button onClick={handleSubmit} disabled={submitted} className="px-4 py-2 bg-green-400 hover:bg-green-300 rounded-md text-white" style={{textShadow: '1px 1px 3px black'}}>
                            Submit Answer
                        </button>
                    </div>
                </>}
            </div>
        </div>
    );
};

export default QuestionBox;
